export default function getStorageConfig() {
  const host = window.location.hostname;
  console.log("Storage host:", host);

  switch (host) {
    case "localhost":
    case "dev.bms.rcshealth.io":
    case "www.dev.bms.rcshealth.io":
      return {
        buckets: {
          landing: {
            bucketName: "rcs-health-landing-page-dev",
            region: "us-east-1",
          },
          bms: {
            bucketName: "rcs-health-dev-v2",
            region: "us-east-1",
          },
          // knowledgebase: {
          //   bucketName: "rcs-health-upload-kbdata",
          //   region: "us-east-1",
          // },
        },
      };

    case "uat.bms.rcshealth.io":
    case "www.uat.bms.rcshealth.io":
      return {
        buckets: {
          landing: {
            bucketName: "rcs-health-landing-page-uat",
            region: "us-east-1",
          },
          bms: {
            bucketName: "rcs-health-uat-v2",
            region: "us-east-1",
          },
          // knowledgebase: {
          //   bucketName: "rcs-health-upload-kbdata",
          //   region: "us-east-1",
          // },
        },
      };

    case "bms.rcshealth.io":
    case "www.bms.rcshealth.io":
      // case "localhost":
      return {
        buckets: {
          landing: {
            bucketName: "rcs-health-landing-page-prod1",
            region: "us-east-1",
          },
          bms: {
            bucketName: "rcs-health-prod1",
            region: "us-east-1",
          },
          // knowledgebase: {
          //   bucketName: "rcs-health-prod1",
          //   region: "us-east-1",
          // },
        },
      };

    default:
      return {
        buckets: {
          landing: {
            bucketName: "rcs-health-landing-page-dev",
            region: "us-east-1",
          },
          bms: {
            bucketName: "rcs-health-dev-v2",
            region: "us-east-1",
          },

        },
      };
  }
}
// function getEnvironment() {
//   const host = window.location.hostname;

//   // Local development
//   if (host === "localhost") {
//     return "dev";
//   }

//   // Production
//   if (host === "bms.rcshealth.io" || host === "www.bms.rcshealth.io") {
//     return "prod1";
//   }

//   // uat
//   if (host === "uat.bms.rcshealth.io" || host === "www.uat.bms.rcshealth.io") {
//     return "uat";
//   }

//   return host.replace("www.", "").split(".")[0];
// }

// export default function getStorageConfig() {
//   const host = window.location.hostname;
//   const env = getEnvironment();

//   console.log("Storage host:", host);
//   console.log("Storage environment:", env);

//   const buckets = {
//     landing: {
//       bucketName: `rcs-health-landing-page-${env}`,
//       region: "us-east-1",
//     },
//     bms: {
//       bucketName: `rcs-health-${env}-v2`,
//       region: "us-east-1",
//     },
//     knowledgebase: {
//       bucketName: "rcs-health-upload-kbdata",
//       region: "us-east-1",
//     },

//   };
//   return { buckets };
// }